import { render, staticRenderFns } from "./ExamAmount.vue?vue&type=template&id=516433b6&scoped=true"
import script from "./ExamAmount.vue?vue&type=script&lang=js"
export * from "./ExamAmount.vue?vue&type=script&lang=js"
import style0 from "./ExamAmount.vue?vue&type=style&index=0&id=516433b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516433b6",
  null
  
)

export default component.exports